// import {ISGTrackData} from "../SDK/SDK";

export const MAP_TRACKS = new Map<string, string>([
    ['machu-1', 'FTUE_11_MapIsVisible1'],
    ['machu-2', 'FTUE_17_MapIsVisible2'],
    ['machu-3', 'FTUE_23_MapIsVisible3'],
]);

export const PRELEVEL_SHOWN_TRACKS = new Map<string, string>([
    ['machu-2', 'FTUE_12_Level2PreLevelIsVisible'],
    ['machu-3', 'FTUE_18_Level3PreLevelIsVisible'],
    ['machu-4', 'FTUE_24_Level4PreLevelIsVisible'],
    ['machu-5', 'FTUE_30_Level5PreLevelIsVisible'],
    ['machu-6', 'FTUE_33_Level6PreLevelIsVisible'],
    ['machu-7', 'FTUE_35_Level7PreLevelIsVisible'],
]);

export const PRELEVEL_CLOSE_TRACKS = new Map<string, string>([
    ['machu-2', 'FTUE_13b_Level2PreLevelButtonClose'],
    ['machu-3', 'FTUE_19b_Level3PreLevelButtonClose'],
    ['machu-4', 'FTUE_25b_Level4PreLevelButtonClose'],
]);

export const PRELEVEL_PLAY_TRACKS = new Map<string, string>([
    ['machu-2', 'FTUE_13a_Level2PreLevelButtonPlay'],
    ['machu-3', 'FTUE_19a_Level3PreLevelButtonPlay'],
    ['machu-4', 'FTUE_25a_Level4PreLevelButtonPlay'],
]);

export const BOARD_SHOWN_TRACKS = new Map<string, string>([
    ['machu-1', 'FTUE_03_Level1BoardIsVisible'],
    ['machu-2', 'FTUE_14_Level2BoardIsVisible'],
    ['machu-3', 'FTUE_20_Level3BoardIsVisible'],
    ['machu-4', 'FTUE_26_Level4BoardIsVisible'],
    ['machu-5', 'FTUE_31_Level5BoardIsVisible'],
]);

export const MATCH_TRACKS = new Map<string, string[]>([
    ['machu-1', ['FTUE_05_FirstMatch', 'FTUE_06_SecondMatch']],
    ['machu-2', ['FTUE_15_Level2FirstMatch']],
    ['machu-3', ['FTUE_21_Level3FirstMatch']],
    ['machu-4', ['FTUE_27_Level4FirstMatch']],
]);

export const SELECT_TRACKS = new Map<string, string[]>([['machu-1', ['FTUE_04_TapOnFirstTile']]]);

export const WIN_SHOWN_TRACKS = new Map<string, string>([
    ['machu-1', 'FTUE_07_WinScreenVisible'],
    ['machu-2', 'FTUE_16_Level2WinScreenIsVisible'],
    ['machu-3', 'FTUE_22_Level3WinScreenIsVisible'],
    ['machu-4', 'FTUE_29_Level4WinScreenIsVisible'],
    ['machu-5', 'FTUE_32_Level5WinScreenIsVisible'],
    ['machu-6', 'FTUE_34_Level6WinScreenIsVisible'],
    ['machu-7', 'FTUE_37_Level7WinScreenIsVisible'],
    ['machu-8', 'FTUE_38_Level8WinScreenIsVisible'],
    ['machu-9', 'FTUE_39_Level9WinScreenIsVisible'],
    ['machu-10', 'FTUE_40_Level10WinScreenIsVisible'],
]);

export const WIN_DISMISSED_TRACKS = new Map<string, string>([['machu-1', 'FTUE_10_TapOnNext']]);

export const WIN_REWARD_TRACKS = new Map<string, string>([['machu-1', 'FTUE_08_RewardClaimed']]);

export const WIN_AD_TRACKS = new Map<string, string>([['machu-1', 'FTUE_09_RewardAdWatched']]);

export const FIND_TRACKS = new Map<string, string>([]);

export const BOOSTER_TRACKS = new Map<string, string>([]);
